// @flow
import { renderGlobalNotifications } from './utils';

/**
 * RTK Query Middleware for Global Notification Handling
 *
 * This middleware intercepts fulfilled RTK Query MUTATION actions and passes
 * the response payload to `renderGlobalNotifications`, which checks for a
 * `ui_notifications` key and displays toast notifications if present.
 *
 * Flow:
 * 1. Intercept all Redux actions
 * 2. Filter for fulfilled mutation actions only
 * 3. Pass the mutation response payload to renderGlobalNotifications
 *
 * Reference: https://redux-toolkit.js.org/rtk-query/usage/error-handling
 */

// Helper to check if the action is a fulfilled RTK Query mutation
const isMutationFulfilledAction = (action) => {
  return action?.meta?.arg?.type === 'mutation' && action?.meta?.requestStatus === 'fulfilled';
};

export const rtkQueryNotificationMiddleware = () => (next) => (action) => {
  if (isMutationFulfilledAction(action)) {
    renderGlobalNotifications(action.payload);
  }

  return next(action);
};
